import {
    AppDispatch,
    RootState,
} from '../../store';
import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
    selectProduct,
    selectSelectedCategories,
    setInitialState,
    toggleAccordionItem,
    toggleCategory,
} from './slice';
import { getDeviceOverview } from './api/glados';
import {
    TRACKING_INFORMATION_ACTION_REVEAL,
    TrackingFilterType,
    TrackingInformationTrigger,
    TrackingInformationUiType,
    trackIt,
    TrackType,
} from '@vfde-sails/tracking';
import {
    createPageViewTrackingData,
    createTrackingFilterObject,
} from './helpers/tracking';
import { selectSelectedProduct } from './selectors';
import {
    createUrlWithQueryString,
    updateUrl,
} from '@vfde-sails/utils';
import { CATEGORY_QUERYPARAM } from 'Constant';

const stoneDopListener = createListenerMiddleware();

export const startAppListening = stoneDopListener.startListening.withTypes<
    RootState,
    AppDispatch
>();

startAppListening({
    actionCreator: setInitialState,
    effect: (action, listenerApi) => {
        const paymentMethod = action.payload.paymentMethod;

        listenerApi.dispatch(getDeviceOverview.initiate(paymentMethod));
    },
});

// Track page view after query for devices was successful
startAppListening({
    matcher: getDeviceOverview.matchFulfilled,
    effect: (action, listenerApi) => {
        const selectedCategories = selectSelectedCategories(listenerApi.getState());

        const trackingData = createPageViewTrackingData({
            selectedCategories,
        });

        trackIt(
            TrackType.PageView,
            trackingData,
        );

        // We only need to track on first successful API request
        listenerApi.unsubscribe();
    },
});

startAppListening({
    actionCreator: selectProduct,
    effect: (action, listenerApi) => {
        const selectedProduct = selectSelectedProduct(listenerApi.getState());

        if (selectedProduct) {
            window.location.assign(selectedProduct.hubpageUrl);
        }
    },
});

startAppListening({
    actionCreator: toggleCategory,
    effect: (action, listenerApi) => {
        const selectedCategories = selectSelectedCategories(listenerApi.getState());

        updateUrl(
            createUrlWithQueryString(
                CATEGORY_QUERYPARAM,
                selectedCategories.map(category => category.label).toString(),
            ),
            true,
        );

        const trackingFilterType = selectedCategories.some(selectedCategory => selectedCategory.label === action.payload.label)
            ? TrackingFilterType.Add
            : TrackingFilterType.Remove;

        const updatedFilter = [createTrackingFilterObject(action.payload.label)];
        const appliedFilters = selectedCategories.map(selectedCategory => createTrackingFilterObject(selectedCategory.label));

        const trackingPayload = {
            action: trackingFilterType,
            updatedFilter,
            appliedFilters,
        };

        trackIt(TrackType.FilterProducts, trackingPayload);
    },
});

startAppListening({
    actionCreator: toggleAccordionItem,
    effect: action => {
        if (!action.payload.optOpen) {
            return;
        }

        const trackingPayload = {
            /* eslint-disable camelcase, @typescript-eslint/naming-convention */
            information_action: TRACKING_INFORMATION_ACTION_REVEAL,
            information_ui_type: TrackingInformationUiType.Faq,
            information_trigger: TrackingInformationTrigger.Accordion,
            information_name: action.payload.stdHeadline,
            /* eslint-enable camelcase, @typescript-eslint/naming-convention */
        };

        trackIt(TrackType.Information, trackingPayload);
    },
});

export default stoneDopListener;
